import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Box, Radio, Typography } from '@material-ui/core';
import { useProductContainerStyles } from './styles';
import NoImage from '../../../../assets/noImage.png';
import { formatDateWithoutTime } from '../../../../helpers/ProductHelper';
import {
  setRut,
  setOrderId,
  setSku,
  setPurchaseDate,
  setCommune,
  setCud,
  setTitle,
  setImageUrl,
  setPrice,
} from '../../../../redux/slices/IssuesSlice';
import { setAuthorized } from '../../../../redux/slices/RoutesAuthSlice';

const ProductContainer = ({ ...props }) => {
  const {
    value,
    onChange,
    title,
    sku,
    purchaseDate,
    mobile,
    product,
    redirect,
    state,
    commune,
    orderId,
    issueFormName,
    cud,
    price,
  } = props;

  const classes = useProductContainerStyles({ mobile });
  const dispatch = useDispatch();
  const [image, setImage] = useState('');

  const handleChange = (e) => {
    onChange(e.target.value);
    dispatch(setOrderId(orderId));
    dispatch(setSku(sku));
    dispatch(setPurchaseDate(purchaseDate));
    dispatch(setCommune(commune));
    dispatch(setCud(cud));
    dispatch(setTitle(title));
    dispatch(setPrice(price));
    dispatch(setImageUrl(product.image));
    dispatch(setAuthorized(true));
  };

  useEffect(() => {
    if (product && product.image) setImage(product.image);
  }, [product]);

  const rutForm = state.rut?.value;

  useEffect(() => {
    if (rutForm) dispatch(setRut(rutForm));
  }, [rutForm]);

  return (
    <Box
      display="flex"
      alignItems="center"
      marginTop="16px"
      marginBottom="16px"
    >
      <Link
        to={{ pathname: redirect }}
        data-cy={issueFormName ? `radio${issueFormName}` : `radio`}
      >
        <Radio
          data-cy={`radio${issueFormName}`}
          className={classes.radio}
          checked={value === sku}
          value={sku}
          onChange={handleChange}
        />
      </Link>
      <img className={classes.image} src={image ? image : NoImage} alt="" />
      <Box className={classes.textContainer}>
        <Typography className={classes.title}>{title} </Typography>
        <Typography className={classes.text}>SKU: {sku} </Typography>
        <Typography className={classes.text}>
          Fecha de compra: {formatDateWithoutTime(purchaseDate)}{' '}
        </Typography>
      </Box>
    </Box>
  );
};

ProductContainer.propTypes = {
  checked: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  image: PropTypes.string,
  title: PropTypes.string,
  sku: PropTypes.string,
  purchaseDate: PropTypes.string,
  mobile: PropTypes.bool,
  product: PropTypes.object,
  products: PropTypes.array,
  redirect: PropTypes.string,
  state: PropTypes.object,
  commune: PropTypes.string,
  orderId: PropTypes.string,
  issueFormName: PropTypes.string,
  status: PropTypes.string,
  shippedDate: PropTypes.string,
  cud: PropTypes.string,
  price: PropTypes.string,
};

export default ProductContainer;
